export default {
  EXCLUSIVE: 0,
  GENERAL: 1,
  DEVELOPER: 2
}